import API from './api';

const host = process.env.REACT_APP_API_HUB;

export const getNotificacoes = () => API.get(`${host}/notificacoes/v1/broadcasting/listar-mensagens`);

export const marcarMensagemComo = params =>
  API.put(`${host}/notificacoes/v1/broadcasting/marcar-mensagem-como`, params);
